import { isEmpty } from "lodash";
import request from "../../services/request";

export const getAcfs = async (limit = 200) =>
  request.get(`/wp-json/acf/v3/posts?per_page=${limit}`).then(res => {
    const { data } = res;
    if (isEmpty(data)) {
      return {};
    }
    return data.reduce((acc, item) => {
      if (item) {
        acc[item.id] = item;
      }
      return acc;
    }, {});
  });

export default {};
